import { render, staticRenderFns } from "./SystemOperationsPage.vue?vue&type=template&id=227004e4"
import script from "./SystemOperationsPage.vue?vue&type=script&lang=js"
export * from "./SystemOperationsPage.vue?vue&type=script&lang=js"
import style0 from "./SystemOperationsPage.vue?vue&type=style&index=0&id=227004e4&prod&lang=scss&scopes=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports